import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const cloningCampaign = {
  popover: {
    title: 'Cloning a Campaign',
    description:
      'Cloning a campaign allows you to quickly create variations of an existing campaigns without starting from scratch.',
    onNextClick: () => {
      const layoutBtns = document.querySelectorAll('div.toolbar > div.filters > div.display-options > div');

      if (layoutBtns[0].children[0].classList.contains('active')) {
        layoutBtns[0].children[1].click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      } else {
        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
